import { render, staticRenderFns } from "./warehouseStatisticsWindow.vue?vue&type=template&id=1b2b9322&scoped=true&"
import script from "./warehouseStatisticsWindow.vue?vue&type=script&lang=js&"
export * from "./warehouseStatisticsWindow.vue?vue&type=script&lang=js&"
import style0 from "./warehouseStatisticsWindow.vue?vue&type=style&index=0&id=1b2b9322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b9322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2b9322')) {
      api.createRecord('1b2b9322', component.options)
    } else {
      api.reload('1b2b9322', component.options)
    }
    module.hot.accept("./warehouseStatisticsWindow.vue?vue&type=template&id=1b2b9322&scoped=true&", function () {
      api.rerender('1b2b9322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FrontEndWarehouse/components/warehousing/warehouseStatisticsWindow.vue"
export default component.exports